import React from "react";
import { useDialogContext } from "../utils/dialog-context.tsx";

interface AuthSectionLayout {
  children: React.ReactNode;
  outerContainerClassName?: string;
}

export const AuthSectionLayout: React.FC<AuthSectionLayout> = ({ children, outerContainerClassName }) => {
  const dialogContext = useDialogContext();

  // if in dialog, don't add layout wrappers
  if (dialogContext) {
    return <>{children} </>;
  }

  return (
    <div className={`w-full ${outerContainerClassName ?? ""}`}>
      <div className="w-auto mx-auto px-3.5 sm:px-7.5">
        <div className="flex content-center max-w-espc-max-content mx-auto w-full py-7.5 md:py-12 lg:py-14">
          {children}
        </div>
      </div>
    </div>
  );
};
